import React from 'react';
import { motion } from 'framer-motion';
import { Loader2, CheckCircle, AlertTriangle, X } from 'lucide-react';

const IngestionProgress = ({ ingestStatus, ingestDone, setIngestDone, setIngestStatus }) => {
  if (!ingestStatus && !ingestDone) return null;

  const status = ingestStatus || ingestDone;
  const isRunning = status.status === 'running';
  const isDone = status.status === 'completed';
  const isFailed = status.status === 'failed';
  const pct = status.total > 0 ? Math.round((status.current / status.total) * 100) : 0;

  return (
    <motion.div
      className={`kb-ingest-progress ${isDone ? 'done' : ''} ${isFailed ? 'failed' : ''}`}
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: 'auto' }}
      exit={{ opacity: 0, height: 0 }}
      data-testid="kb-ingest-progress"
    >
      <div className="kb-ingest-progress-header">
        {isRunning && <Loader2 size={18} className="kb-spin" />}
        {isDone && <CheckCircle size={18} />}
        {isFailed && <AlertTriangle size={18} />}
        <span className="kb-ingest-progress-msg">{status.message}</span>
        {(isDone || isFailed) && (
          <button className="kb-dismiss-btn" onClick={() => { setIngestDone(null); setIngestStatus(null); }} data-testid="kb-dismiss-ingest">
            <X size={14} />
          </button>
        )}
      </div>

      {isRunning && status.total > 0 && (
        <div className="kb-ingest-progress-bar-wrap">
          <div className="kb-ingest-progress-bar" style={{ width: `${pct}%` }} />
          <span className="kb-ingest-progress-pct">{pct}%</span>
        </div>
      )}

      <div className="kb-ingest-progress-stats">
        {status.total > 0 && <span>{status.current || 0} / {status.total} files scanned</span>}
        {status.queue_total > 0 && <span>{status.queue_total} in queue</span>}
        {status.processed > 0 && <span>{status.processed} ingested</span>}
        {status.skipped > 0 && <span>{status.skipped} skipped</span>}
        {status.error_count > 0 && <span className="kb-ingest-err-count">{status.error_count} errors</span>}
      </div>
    </motion.div>
  );
};

export default IngestionProgress;
